import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'cs',
    fullName: 'Czech',
    nativeName: 'Čeština',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Něco úžasného se blíží",
    landing_subtitle: "ArgVoid je studio pro vývoj aplikací a her. Zůstaňte naladěni, brzy přijdou nové věci!",
    select_language: "Vyberte Jazyk",
    search_placeholder: "Hledat jazyky...",
    terms_title: "Podmínky služby",
    policy_title: "Zásady ochrany osobních údajů",
    cookies_title: "Zásady používání souborů cookie",
    terms_content: `
        <strong>1. Přijetí podmínek</strong><br>
        Přístupem na ArgVoid přijímáte tyto Podmínky služby. Pokud s těmito podmínkami nesouhlasíte, službu byste neměli používat.<br><br>

        <strong>2. Využití platformy</strong><br>
        ArgVoid a jeho aplikace jsou poskytovány „tak jak jsou“ pro informační a kreativní účely. Služba musí být používána pouze pro zákonné účely.<br><br>

        <strong>3. Zakázané chování</strong><br>
        Zneužívání zranitelných míst webu, spamování nebo pokusy o neoprávněný přístup k infrastruktuře je přísně zakázáno.<br><br>

        <strong>4. Zřeknutí se odpovědnosti</strong><br>
        Platforma a služby mohou být kdykoli bez upozornění změněny. Není poskytována žádná záruka týkající se provozuschopnosti nebo dostupnosti služby.
    `,
    policy_content: `
        <strong>1. Sbírka informací</strong><br>
        Platforma v současné době nevyžaduje ověření uživatele ani vytvoření účtu. Od návštěvníků nejsou aktivně shromažďovány žádné osobní identifikační údaje (jako jsou jména nebo e-mailové adresy).<br><br>

        <strong>2. Použití Data</strong><br>
        Základní, anonymizované analýzy mohou být shromažďovány za účelem pochopení návštěvnosti webu a vylepšení aplikací. Tato data nejsou spojena s totožnostmi jednotlivých uživatelů.<br><br>

        <strong>3. Služby třetích stran</strong><br>
        Pro hostování a analytické služby mohou být využiti poskytovatelé třetích stran. Postupy ochrany osobních údajů těchto příslušných poskytovatelů se řídí anonymními údaji zpracovávanými na jejich infrastruktuře.<br><br>

        <strong>4. Zabezpečení dat</strong><br>
        K ochraně platformy jsou implementována přiměřená bezpečnostní opatření. Žádný způsob přenosu přes internet však není zcela bezpečný.<br><br>
    `,
    cookies_content: `
        <strong>1. Co jsou soubory cookie a místní úložiště?</strong><br>
        Soubory cookie a místní úložiště prohlížeče jsou malé datové soubory uložené v zařízení k zapamatování předvoleb konfigurace během návštěv.<br><br>

        <strong>2. Účel použití</strong><br>
        Prohlížeč LocalStorage se používá výhradně k ukládání konfiguračních nastavení, jako je: <br>
        - Předvolby jazyka<br>
        - Konfigurace uživatelského rozhraní (např. nastavení rozložení nebo motivu) <br>
        - Dočasná mezipaměť aplikace<br><br>

        <strong>3. Žádné sledování</strong><br>
        Soubory cookie a místní úložiště se nepoužívají pro reklamní účely ani pro účely sledování třetích stran. Všechna uložená data jsou výhradně pro základní funkce platformy.<br><br>

        <strong>4. Control</strong><br>
        Data prohlížeče lze kdykoli vymazat prostřednictvím nastavení prohlížeče, které resetuje všechny místní konfigurace.
    `,
    cookie_consent_text: "Základní soubory cookie používáme k zajištění správného fungování webových stránek, jako je udržování vaší relace aktivní, ukládání vašich jazykových preferencí a další vlastní konfigurace.",
    read_policy: "Přečtěte si Zásady používání souborů cookie",
    support_title: "Kontaktujte podporu",
    support_subject_label: "Podrobit",
    support_message_label: "Zpráva",
    support_submit_button: "Odeslat zprávu",
    support_hint: "Poznámka: Tím se otevře vaše výchozí e-mailová aplikace pro odeslání zprávy.",
    support_success_msg: "Otevírání vaší e-mailové aplikace...",
    support_error_msg: "Odeslání zprávy se nezdařilo. Zkuste to znovu později.",
    explorer_title: "Badatel",
    history_title: "Dějiny",
    animation_title: "Animace",
    config_title: "Konfigurace",
    tool_mouse: "Vybrat (Ctrl+M)",
    tool_brush: "Štětec (Ctrl+B)",
    tool_brush_mode: "Přepnout režim (plné/jasné)",
    tool_eraser: "Guma (Ctrl+E)",
    tool_brush_size: "Upravte velikost štětce",
    tool_bucket: "Vyplnit (Ctrl+F)",
    tool_eyedropper: "Kapátko",
    tool_grid: "Mřížka (Ctrl+Shift+B)",
    tool_rotate: "Otočit (Ctrl+Shift+R)",
    tool_flip_h: "Otočit H (Ctrl+Shift+H)",
    tool_flip_v: "Otočit V (Ctrl+Shift+V)",
    tool_transpose: "Transponovat (Ctrl+Shift+T)",
    label_width: "Šířka",
    label_height: "Výška",
    label_frames: "Počet snímků",
    label_animation: "Styl animace",
    label_background_color: "Barva pozadí",
    label_interval: "Interval",
    tool_anim_config: "Konfigurace animace",
    label_new_width: "Nová šířka",
    label_new_height: "Nová výška",
    label_apply: "Použít",
    label_colors: "Barvy",
    label_size: "Velikost",
    label_tolerance: "Tolerance",
    val_horizontal: "Horizontální",
    val_vertical: "Vertikální",
    val_sequence: "Sekvence",
    val_bounce: "Odskočit",
    val_random: "Náhodný",
    val_solid: "Solidní",
    val_clear: "Jasný",
    action_add_sheet: "Nový list",
    action_import: "Importovat",
    action_export: "Vývozní",
    action_sort_projects: "Seřadit",
    sort_date_old: "Nejstarší první",
    sort_date_new: "Nejnovější první",
    sort_name_az: "Jméno (A–Z)",
    sort_name_za: "Jméno (Z-A)",
    action_new_sprite: "Nový Sprite",
    action_new_project: "Nový projekt",
    modal_save_all_title: "Uložit všechny změny",
    modal_save_all_desc: "Vyberte aktiva, která chcete uložit:",
    modal_save_selected: "Uložit vybrané",
    action_saved: "Uloženo",
    modal_create_sprite_title: "Vytvořit nového Sprite",
    modal_create_project_title: "Vytvořit nový projekt",
    modal_add_sheet_title: "Přidat nový list",
    modal_rename_sheet_title: "Přejmenovat list",
    modal_rename_sprite_title: "Přejmenovat Sprite",
    modal_delete_sprite_title: "Smazat Sprite",
    modal_delete_project_title: "Smazat projekt",
    modal_delete_sheet_title: "Smazat list",
    placeholder_sprite_name: "Jméno",
    placeholder_project_name: "Jméno",
    placeholder_sheet_name: "Jméno",
    placeholder_new_name: "Nové jméno",
    action_create: "Vytvořit",
    action_add: "Přidat",
    action_rename: "Přejmenovat",
    action_duplicate: "Duplikát",
    action_delete: "Vymazat",
    action_cancel: "Zrušit",
    confirm_delete_sprite: "Opravdu chcete tohoto sprite smazat?",
    confirm_delete_project: "Opravdu chcete tento projekt smazat? Všichni skřítci budou odstraněni.",
    confirm_delete_sheet: "Opravdu chcete tento list smazat?",
    err_select_sprite: "Nejprve prosím vyberte sprite.",
    err_select_project: "Nejprve prosím vyberte projekt.",
    err_name_empty: "Název nemůže být prázdný.",
    err_sprite_exists: "Sprite s tímto jménem již existuje.",
    err_project_exists: "Projekt s tímto názvem již existuje.",
    err_no_content: "Žádný obsah k uložení.",
    err_no_changes: "Žádné změny k uložení.",
    err_delete_last_sheet: "Nelze smazat poslední list.",
    err_extract_frames: "Nelze extrahovat žádné snímky.",
    err_indexeddb: "Lokální uložení se nezdařilo. Váš prohlížeč možná nepodporuje IndexedDB.",
    msg_upload_success: "Nahrání bylo úspěšné: {0}",
    msg_upload_failed: "Nahrávání se nezdařilo: {0}",
    msg_save_success: "Uložení proběhlo úspěšně.",
    msg_saving: "Ukládání...",
    msg_multi_save_result: "Počet uložených děl: {0}. {1} selhání.",
    menu_title: "Menu",
    menu_save: "Uložit",
    menu_save_all: "Uložit vše",
    menu_support: "Kontaktujte podporu",
    label_local_storage: "Místní úložiště",
    label_sign_in: "Přihlaste se",
    modal_export_title: "Export Sprite",
    label_filename: "Název souboru",
    label_format: "Formát",
    action_export_confirm: "Vývozní",
};

export default translations;
